/**
 * Central GA4 event helper. Uses `window.gtag` after {@link initializeGoogleAnalytics} runs.
 */

const FUNNEL_DEDUPE_PREFIX = 'lp_ga_funnel_v1:';

function getGtag(): ((...args: unknown[]) => void) | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return typeof window.gtag === 'function' ? window.gtag : undefined;
}

/**
 * Sends a GA4 event. No-op if gtag is not available.
 */
export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  const gtag = getGtag();
  if (!gtag) {
    return;
  }
  if (params && Object.keys(params).length > 0) {
    gtag('event', eventName, params);
  } else {
    gtag('event', eventName);
  }
}

/**
 * Fires a funnel event at most once per browser for a given dedupe key (e.g. `onboarding_start:my-tenant`).
 * Survives full page reloads; scoped per tenant slug in the key so different workspaces are tracked separately.
 */
export function trackFunnelEventOnce(
  dedupeKey: string,
  eventName: string,
  params?: Record<string, unknown>,
): void {
  const key = `${FUNNEL_DEDUPE_PREFIX}${dedupeKey}`;
  try {
    if (typeof localStorage !== 'undefined') {
      if (localStorage.getItem(key) === '1') {
        return;
      }
      localStorage.setItem(key, '1');
    }
    trackEvent(eventName, params);
  } catch {
    trackEvent(eventName, params);
  }
}
